export interface ZipCode {
  street: string;
  housenumber: string;
  postalcode: string;
  city: string;
}

export interface IncorrectZipCode {
  errors: Array<ZipCodeError>;
}

export interface ZipCodeError {
  message: string;
  code: ZipCodeErrorEnum;
}

/* eslint-disable import/prefer-default-export */
// Disable eslint error because of a TypeScript bug
export enum ZipCodeErrorEnum {
  ZIP_CODE_ADDRESS_NOT_FOUND = 'ZIP_CODE_ADDRESS_NOT_FOUND',
  ZIP_CODE_VALIDATION_FAILED = 'ZIP_CODE_VALIDATION_FAILED',
}
/* eslint-enable import/prefer-default-export */

export interface ServiceNotReached {
  message: string;
}
